"use client";

import { ExternalLink, Instagram } from "lucide-react";
import type { InstagramStats } from "@/types";
import { Button } from "@/ui";

interface InstagramHeaderProps {
  stats?: InstagramStats;
}

export default function InstagramHeader({ stats }: InstagramHeaderProps) {
  const { posts = 0, followers = 0, rating = 0 } = stats || {};

  const handleFollowClick = () => {
    // TODO: Add your actual Instagram URL
    window.open("#", "_blank");
  };

  return (
    <div className="mb-16 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Instagram Profile Style Header */}
        <div className="flex flex-col sm:flex-row gap-8">
          {/* Left Side: Profile Picture & Info */}
          <div className="flex flex-col sm:flex-row gap-4 flex-1">
            {/* Profile Picture */}
            <div className="flex justify-center sm:justify-start">
              <div className="w-20 h-20 sm:w-24 sm:h-24 bg-gradient-to-br from-purple-500 via-pink-500 to-orange-400 p-0.5 rounded-full">
                <div className="w-full h-full bg-white p-0.5 rounded-full overflow-hidden">
                  <div className="w-full h-full bg-black rounded-full flex items-center justify-center">
                    <Instagram className="w-8 h-8 text-white" />
                  </div>
                </div>
              </div>
            </div>

            {/* Profile Info */}
            <div className="flex-1 text-center sm:text-left">
              {/* Username & Follow Button */}
              <div className="flex flex-col sm:flex-row sm:items-center gap-3 mb-3">
                <h2 className="text-xl sm:text-2xl font-light text-black">
                  mammamia_pizza
                </h2>
                <Button
                  variant="primary"
                  size="sm"
                  onClick={handleFollowClick}
                  className="inline-flex items-center gap-2 text-sm px-4 py-1.5"
                >
                  Follow
                  <ExternalLink className="w-3 h-3" />
                </Button>
              </div>

              {/* Bio/Title */}
              <div className="mb-4">
                <h3 className="text-base font-semibold text-black mb-1">
                  🍕 Authentic Italian Cuisine
                </h3>
                <p className="text-sm text-black/70">
                  Behind the scenes • Downtown Italian District
                </p>
              </div>
            </div>
          </div>

          {/* Right Side: Instagram Stats */}
          <div className="flex justify-center sm:justify-end gap-8 lg:gap-12 min-w-fit">
            <div className="text-center">
              <div className="text-2xl lg:text-3xl font-semibold text-black mb-1">
                {posts}
              </div>
              <div className="text-xs lg:text-sm text-black/60 font-medium">
                posts
              </div>
            </div>

            <div className="text-center">
              <div className="text-2xl lg:text-3xl font-semibold text-black mb-1">
                {followers}
              </div>
              <div className="text-xs lg:text-sm text-black/60 font-medium">
                followers
              </div>
            </div>

            <div className="text-center">
              <div className="text-2xl lg:text-3xl font-semibold text-black mb-1">
                {rating}
              </div>
              <div className="text-xs lg:text-sm text-black/60 font-medium">
                rating
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
